import {Box, Stack, Typography} from '@mui/material';
import DailyCareLogOccurrenceCard from '../../../../components/occurrences/occurrence-card/occurrence-card';
import {TransformedOccurrence} from '../../../../utils/data/occurrences';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../i18n/translations';
import {ScreenPaths} from '../../../../enums';
import {useHistory} from 'react-router-dom';
import {TaskFilterHeader} from '../../../../components/daily-care-log/task-table/task-filter-header';
import {useDailyCareLogFilters} from '../../../../contexts/dailycare-log-filters/context';
import {Moment} from 'moment';

type OccurrencesListProps = {
  entityId: string;
  occurrences: TransformedOccurrence[];
  selectedDay: Moment;
  onFiltersOpen: () => void;
};

export default function OccurrencesList({
  entityId,
  occurrences,
  selectedDay,
  onFiltersOpen,
}: OccurrencesListProps) {
  const {t} = useTranslation();
  let history = useHistory();
  const {tasksFilters} = useDailyCareLogFilters();

  if (occurrences.length === 0) {
    return (
      <Stack gap="12px" className="occurrences-empty" flexDirection="column">
        <TaskFilterHeader
          title={t(translations.daily_care_log.tabs.occurrences)}
          subtitleDay={selectedDay.format('YYYY-MM-DD')}
          onFilterClick={() => onFiltersOpen()}
        />
        <Stack alignItems="center" flexGrow="1" flexDirection="column">
          <Stack marginTop="auto" marginBottom="auto">
            <Typography className="empty-title">
              {tasksFilters.socialResponseIds.length > 0 ||
              tasksFilters.status.length > 0 ||
              tasksFilters.occurrencesTypesGeneral.length > 0 ||
              tasksFilters.occurrencesTypesPatients.length > 0 ||
              tasksFilters.users.length > 0
                ? t(translations.daily_care_log.occurrences.empty_filters_title)
                : t(translations.daily_care_log.occurrences.empty_title)}
            </Typography>
            <Typography className="empty-subtitle">
              {t(translations.daily_care_log.occurrences.empty_subtitle)}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack className="occurrences-list" direction="column" gap="10px">
      <TaskFilterHeader
        title={t(translations.daily_care_log.tabs.occurrences)}
        subtitleDay={selectedDay.format('YYYY-MM-DD')}
        onFilterClick={() => onFiltersOpen()}
      />
      {occurrences.map((occurrence) => {
        return (
          <DailyCareLogOccurrenceCard
            key={occurrence.id}
            id={occurrence.id}
            type={occurrence.type}
            name={occurrence.patient?.name || ''}
            picture={occurrence.patient?.picture || ''}
            date={occurrence.registeredAt}
            borderColor={occurrence.patient?.socialResponses[0]?.foregroundColor || ''}
            status={occurrence.status}
            onSelect={(id: string) =>
              history.push(
                `${ScreenPaths.DailyCareLog}/${entityId}${ScreenPaths.DailyCareLog_Occurrences}/${id}?date=${selectedDay.format('YYYY-MM-DD')}`,
                {
                  ...occurrence,
                }
              )
            }
          />
        );
      })}
      {/* Add bottom space */}
      <Box sx={{minHeight: 86 + 56 + 18}}></Box>
    </Stack>
  );
}
